import { Action, MemoizedSelectorWithProps, Store } from '@ngrx/store';
import { dispatchAction, takeOne, takeAll } from '../utils/ngrx-utils';

export abstract class BaseFacade {

  protected constructor(protected appState$: Store<any>) {
  }

  dispatch = (action: Action) => dispatchAction(this.appState$, action);
  takeOne = <T, U, V>(selector: MemoizedSelectorWithProps<T, U, V>, params?: any) => takeOne(
    this.appState$, selector, params
  );
  takeAll = <T, U, V>(selector: MemoizedSelectorWithProps<T, U, V>, params?: any) => takeAll(
    this.appState$, selector, params
  );
}
